<template>
  <div class="tests-container">
    <div v-if="loading" class="loading">
      Chargement des tests...
    </div>
    
    <div v-else>
      <h2>Tests psychométriques à passer</h2>
      
      <div v-if="availableTests.length === 0" class="no-tests">
        Aucun test n'est disponible pour le moment.
      </div>
      
      <div v-else class="tests-grid">
        <div v-for="test in availableTests" :key="test.id" class="test-card">
          <div class="test-header">
            <h3>{{ test.name }}</h3>
            <span class="duration">Durée: {{ test.duration_minutes }} minutes</span>
          </div>
          
          <div class="test-body">
            <p>{{ test.description }}</p>
          </div>
          
          <div class="test-status">
            <span v-if="test.completed" class="completed">
              Test complété
            </span>
            <span v-else-if="test.in_progress" class="in-progress">
              Test en cours
            </span>
            <button v-else 
                    @click="startTest(test)"
                    class="start-button">
              Commencer le test
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestsList',
  
  data() {
    return {
      loading: true,
      availableTests: [],
      currentJobId: null
    }
  },

  created() {
    // Récupérer l'ID du poste depuis l'URL ou les props
    this.currentJobId = this.$route.params.jobId;
    this.loadTests();
  },

  methods: {
    async loadTests() {
      try {
        const response = await this.$http.get(`/api/jobs/${this.currentJobId}/tests`);
        this.availableTests = response.data.tests;
      } catch (error) {
        console.error('Erreur lors du chargement des tests:', error);
      } finally {
        this.loading = false;
      }
    },

    async startTest(test) {
      try {
        const response = await this.$http.post(`/api/tests/${test.id}/start`);
        if (response.data.success) {
          // Rediriger vers le composant spécifique du test
          this.$router.push({
            name: 'test-taking',
            params: { 
              testId: test.id,
              testType: test.type
            }
          });
        }
      } catch (error) {
        console.error('Erreur lors du démarrage du test:', error);
      }
    }
  }
}
</script>

<style scoped>
.tests-container {
  padding: 20px;
}

.tests-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.test-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  background: white;
}

.test-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.duration {
  color: #666;
  font-size: 0.9em;
}

.test-status {
  margin-top: 15px;
  text-align: center;
}

.completed {
  color: green;
}

.in-progress {
  color: orange;
}

.start-button {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.start-button:hover {
  background-color: #45a049;
}
</style> 